// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const StarIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Star/outline"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "m12 0 .006 10.616a1 1 0 0 0 1.309.95l10.098-3.274-10.094 3.286a1 1 0 0 0-.5 1.538l6.234 8.592-6.244-8.584a1 1 0 0 0-1.618 0l-6.244 8.584 6.234-8.592a1 1 0 0 0-.5-1.538L.587 8.292l10.098 3.274a1 1 0 0 0 1.309-.95L12 0Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
export default StarIcon;